export const initial_state={
    /**
     * The language of the app. It can only be "english" or "arabic".
     * 
     * @type {string}
     */
    language:"en",
}